import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { register, reset } from "../../reduxAuth/authSlice";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function AuthRegister() {
  const dispatch                                        = useDispatch();
  const { isLoading, isSuccess, isError, message }      = useSelector((state) => state.auth);
  const navigate                                          = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    dateOfBirth: "",
    password: "",
    subscribe: true,
  });

  useEffect(() => {
    if (isSuccess) {
      toast.success("Registration successful!");
      setFormData({
        name: "",
        surname: "",
        email: "",
        phone: "",
        dateOfBirth: "",
        password: "",
        subscribe: true,
      });
      
      navigate('/thank-you');
    }

    if (isError) {
      toast.error("Registration failed: " + message);
    }

    return () => dispatch(reset());
  }, [isSuccess, isError, message, dispatch]);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.warning("Email is incorrect format");
      return false;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      toast.warning("Phone number must be exactly 10 digits");
      return false;
    }

    const dob = new Date(formData.dateOfBirth);
    const today = new Date();
    const age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();

    if (
      age < 14 ||
      (age === 14 && monthDiff < 0) ||
      (age === 14 && monthDiff === 0 && dayDiff < 0)
    ) {
      toast.warning("You must be at least 14 years old");
      return false;
    }

    if (formData.password.length < 7) {
      toast.warning("Password cannot be less than 7 charactgers");
      return false;
    }
    return true;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    dispatch(register(formData));
  };

  return (
    <div className="auth-layer">
      <p className="grayColor">Your temporary password will be sent to your email. Please update after registration.</p>
       <form onSubmit={onSubmit}>
          <div className="mb-3">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={onChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Surname</label>
            <input
              type="text"
              className="form-control"
              name="surname"
              value={formData.surname}
              onChange={onChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={formData.email}
              onChange={onChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Phone</label>
            <input
              type="tel"
              className="form-control"
              name="phone"
              value={formData.phone}
              onChange={onChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Date of Birth</label>
            <input
              type="date"
              className="form-control"
              name="dateOfBirth"
              value={formData.dateOfBirth}
              onChange={onChange}
              required
            />
          </div>

          <div className="mb-3">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={formData.password}
              onChange={onChange}
              required
            />
            <div className="small">7 Characters or more</div>
          </div>

          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              name="subscribe"
              checked={formData.subscribe}
              onChange={onChange}
              id="subscribeCheck"
            />
            <label className="form-check-label" htmlFor="subscribeCheck">
              Subscribe to newsletter
            </label>
          </div>

          <button type="submit" className="btn btn-main w-100" disabled={isLoading}>
            {isLoading ? "Registering..." : "Register"}
          </button>
        </form>
    </div>
  )
}

export default AuthRegister